import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as authService from '../admin/services/authService';
import { AuthContext } from "../contexts/AuthContext";
import { useLocation } from 'react-router-dom';

export const Logout = () => {
    const { onLogout } = useContext(AuthContext);
    const navigate = useNavigate();

    const location = useLocation();


    useEffect(() => {
        authService.logout()
            .then(() => {

                onLogout();

                if (location.pathname === '/parent/logout' || location.pathname === '/parent/change-password') {
                    navigate('/parent-login');
                } else {
                    navigate('/schadm');
                }
            })
            .catch((error) => {
                alert(error.message);
            })
    }, [])

    return null;
}